import { EditableCard } from "../../../components/editableCard.component";
import { ProfileCardPlaceholder } from "../../../components/placeholders.component";
import { ApiSchemaUser } from "../../../models/api";
import { AppRouteUi } from "../../../config/appRoute";
import { useParams } from "react-router";
import { Image } from "../../../components/image.component";

type Props = {
  data: ApiSchemaUser | undefined;
  isValidating: boolean;
};

export const ProfileCard = (props: Props) => {
  const { userId } = useParams<{ userId: string }>();
  return (
    <EditableCard
      link={`${AppRouteUi.Users.Root()}/update/${userId}`}
      title="Profile"
      isValidating={props.isValidating}
      className="mb-3"
      showEditButton
      showBackButton
    >
      {props.isValidating ? (
        <ProfileCardPlaceholder />
      ) : (
        <div className="d-flex align-items-center mb-3">
          <div>
            <Image
              src=""
              alt="Profile"
              className="p-3 rounded-circle object-fit-cover"
              width={150}
              height={150}
            />
          </div>
          <div className="ms-5">
            <h1 className="display-6">
              {props.data?.firstName} {props.data?.lastName}
            </h1>
            <p>{props.data?.userName}</p>
            <p>{props.data?.department}</p>
          </div>
        </div>
      )}
    </EditableCard>
  );
};
